import * as React from 'react';
import {Box, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Timeline} from "@mui/lab";
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import StoryLine from "./StoryLine";
import {AutoGraph, CloudSync, ControlPointDuplicate, Dataset, ModelTraining} from "@mui/icons-material";
import backgroundImage from "../../assets/img/dashboard/data4.jpg";
import ReactPlayer from "react-player";
// import backgroundDashboard from "public/branding.png"


export default function Dashboard() {
    const {t} = useTranslation(["common", "sidebar", "tutorial"]);
    return (
        <Box sx={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        }}>
            <Grid container paddingTop={1.2}>
                <Grid item xs={12} justifyContent="center">
                    <Typography sx={{
                        fontSize: "48px",
                        fontWeight: 800,
                        letterSpacing: "2px",
                        color: "#1e69da",
                        textShadow: "5px 2px 5px lightblue"
                    }}>
                        Trend Z
                    </Typography>
                </Grid>
                <Grid item xs={12} paddingTop={0.8} paddingBottom={1.8}
                      sx={{display: "flex", justifyContent: "center"}}>
                    <ReactPlayer
                        // url={"videos/DemoVideo.mp4"}
                        url={"https://youtu.be/3dii4tbK5R4"}
                        controls={true}
                        playing={true}
                        loop={true}
                        muted={true}
                        // width="100%"
                        height="320px"
                    />
                </Grid>

                <Grid item xs={1}></Grid>
                <Grid item xs={10} justifyContent="center">
                    <Timeline position="alternate">
                        <StoryLine
                            alignFrom="left"
                            oppositeContent={<Box>image here</Box>}
                            contentTitle={"KHẢ NĂNG VỀ CÔNG NGHỆ"}
                            content={"Chúng tôi là một tập hợp gồm những con người trẻ, đầy nhiệt huyết và có kinh nghiệm rất đa dạng trên nhiều lĩnh vực khác nhau: vận hành hệ thống lẫn doanh nghiệp, trí tuệ nhân tạo, thiết kế phần mềm,... Tất cả các kỹ năng và kinh nghiệm trên được tận dụng để đưa ra những giải pháp hợp lý nhất trước khi sản phẩm được đưa đến người dùng"}
                            icon={<LaptopMacIcon/>}
                        />
                        <StoryLine
                            alignFrom="right"
                            oppositeContent={<Box>image here</Box>}
                            contentTitle={"DỮ LIỆU THỜI GIAN THỰC"}
                            content={"Dữ liệu của TrendZ được thu thập và cập nhật liên tục từ rất nhiều nguồn dữ liệu khác nhau để cung cấp cho bạn những bức tranh đầy đủ và sát với tình hình thực tế nhất"}
                            icon={<Dataset/>}
                        />
                        <StoryLine
                            alignFrom="left"
                            oppositeContent={<Box>image here</Box>}
                            contentTitle={"KHẢ NĂNG TÍCH HỢP"}
                            content={"Khả năng tích hợp với các API bên thứ ba giúp người dùng có thể ngay lập tức có phản ứng với những thông tin mới (tạo công việc, nhắc nhở, thông báo...), nâng cao khả năng phản ứng của doanh nghiệp trước những biến động về thông tin, thị trường, chính sách..."}
                            icon={<ControlPointDuplicate/>}
                        />
                        <StoryLine
                            alignFrom="right"
                            oppositeContent={<Box>image here</Box>}
                            contentTitle={"XÂY DỰNG BÁO CÁO THỜI GIAN THỰC"}
                            content={"Các báo cáo của Trendz được tạo ra hoàn toàn tự động và liên tục, được cập nhật ngay khi có thay đổi trên thực tế, giúp các nhà quản lý có đầy đủ thông số, góc nhìn trước khi đưa ra quyết định"}
                            icon={<AutoGraph/>}
                        />
                        <StoryLine
                            alignFrom="left"
                            oppositeContent={<Box>image here</Box>}
                            contentTitle={"MÔ HÌNH NGÔN NGỮ TIÊN TIẾN"}
                            content={"Là một hệ thống tập trung vào các nội dung số, TrendZ không thể thiếu được các mô hình ngôn ngữ từ nhỏ đến lớn, phục vụ cho các chức năng bao gồm phát hiện từ khóa, đánh giá sắc thái, tóm tắt nội dung... và ở cấp độ cao nhất - một cố vấn chiến lược cho các quyết định của doanh nghiệp"}
                            icon={<ModelTraining/>}
                        />
                        <StoryLine
                            alignFrom="right"
                            oppositeContent={<Box>image here</Box>}
                            contentTitle={"VẬN HÀNH HOÀN TOÀN \"TRÊN MÂY\""}
                            content={"Toàn bộ các thành phần trực tiếp phục vụ người dùng trong hệ thống TrendZ đều được phục vụ trên điện toán đám mây, đảm bảo khả năng mở rộng dễ dàng và giảm thiểu tối đa thời gian sự cố"}
                            icon={<CloudSync/>}
                        />
                    </Timeline>
                </Grid>
                <Grid item xs={1}></Grid>
            </Grid>
        </Box>
    );
}
